<template>
  <div class="d-flex flex-column flex-root" id="kt_app_root">
    <div class="d-flex flex-column h-100">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthLayout',
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title || 'YumBox';
      }
    },
  }
}
</script>

<style scoped>

</style>